import React, { useState } from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import {
  Button,
  FormCheckbox,
  FormField,
  FormInput,
  FormLayout,
  FormToggle,
  OptinLabel,
  WImage,
} from 'components/atoms'
import styles from './FormNewsletter.module.sass'
import { useNewsletterSubscribeMutation, useBrandOptinsQuery } from '@gql/graphql'
import { useRouter } from 'next/router'
import useTrans from '@hooks/useTrans'
import { ModalFeedback, MyOptinsFormCard } from '@components/organisms'
import { subscribe } from 'graphql'

const validationSchema = (t) =>
  yup.object({
    email: yup
      .string()
      .email(t("Il formato dell'email dev'essere valido"))
      .required(t('Questo campo non può essere vuoto')),
    optinMarketing: yup
      .boolean()
      .oneOf([true], t("Devi accettare i termini d'uso")),
  })



const FormNewsletter = ({
  from,
  preferenzeOpenDefault,
  enablePreferenzeToggle,
  brandOptinName,
  brandName,
  brandSlug,
}: {
  from?: string
  preferenzeOpenDefault?: boolean
  enablePreferenzeToggle?: boolean
  brandOptinName?: string
  brandName?: string
  brandSlug?: string
}) => {
  const [newslettersubscribe] = useNewsletterSubscribeMutation()
  const { data: optins, optinsError } = useBrandOptinsQuery()

  const router = useRouter()
  const t = useTrans()

  const nextPage = router.query?.next



  const [modalConfirmCreateAccount, setModalConfirmCreateAccount] = useState(false)
  const [modalErrorCreateAccount, setModalErrorCreateAccount] = useState(false)
  const [error, setError] = useState('')
  const submitBrand = brandName || brandSlug || 'ViviDanone'

  const [preferenzeOpen, setPreferenzeOpen] = useState(preferenzeOpenDefault)

  const optinInitialValues = optins?.brandOptins
    ?.map((o) => o.optinName)
    .reduce((obj, key) => {
      obj[key] = brandOptinName && key === brandOptinName ? true : false
      return obj
    }, {})

  const baseInitialValues = {
    email: (router.query?.email as string) || '',
    optinNewsletter: false,
    optinMarketing: false,
  }

  const initialValues = optins?.brandOptins
    ? {
        ...baseInitialValues,
        ...optins.brandOptins.reduce(
          (obj, optin) => ({
            ...obj,
            [optin.optinName]:
              brandOptinName && optin.optinName === brandOptinName ? true : false,
          }),
          {},
        ),
      }
    : baseInitialValues

  return (
    <Formik
      isInitialValid={false}
      validateOnChange
      onSubmit={(values, { setSubmitting }) => {
        const optinValues = optins?.brandOptins
          ?.map((o) => o.optinName)
          .reduce((obj, key) => {
            obj[key] = values[key]
            return obj
          }, {})

        newslettersubscribe({
          variables: {
            input: {
              email1: values?.email,
              brand: submitBrand,
              brandSlug: brandSlug,
              optins: {
                optinMarketing: values?.optinMarketing,
                optinNewsletter: values?.optinMarketing,
                ...optinValues,
              },
            },
          },
        })
          .then((response) => {
            const data = response.data.newsletterSubscribe?.content
            if (data) {
              if (data.status_code !== 200) {
                setModalErrorCreateAccount(true)
                setError(data.content?.statusDescription[0].errorMessage)
              } else {
                setModalConfirmCreateAccount(true)
              }
            }
          })
          .catch(() => {
            setModalErrorCreateAccount(true)
          })
          .finally(() => setSubmitting(false))
      }}
      initialValues={
        optins?.brandOptins ? { ...initialValues, ...optinInitialValues } : initialValues
      }
      validationSchema={validationSchema(t)}
      enableReinitialize
    >
      {(props) => (
        <>
          <FormLayout className={styles.layout}>
         
            <FormField
              label={t('Email*')}
              layout="full"
              status={
                props.touched?.email
                  ? props.errors?.email
                    ? 'error'
                    : 'success'
                  : null
              }
              errorMessage={props?.errors?.email}
            >
              <FormInput
                onBlur={props.handleBlur('email')}
                placeholder={t('Email')}
                value={props.values?.email}
                onChange={props.handleChange('email')}
              />
            </FormField>
            {enablePreferenzeToggle ? (
              <button
                type="button"
                className={styles.preferenzeTrigger}
                onClick={() => setPreferenzeOpen(!preferenzeOpen)}
                aria-expanded={!!preferenzeOpen}
              >
                {preferenzeOpen
                  ? t('Nascondi le preferenze di ricontatto dei Brand Danone')
                  : t('Di quali brand vuoi ricevere la newsletter?')}
              </button>
            ) : (
              <p className={styles.privacy_title}>
                {t('Di quali brand vuoi ricevere la newsletter?')}
              </p>
            )}
            {preferenzeOpen && (
                  <div className={styles.preferenzeContainer}>
                    {optins?.brandOptins &&
                      optins?.brandOptins?.map((optinBrand) => (
                        <div className={styles.optinBrandCard} key={optinBrand.name}>
                          <div className={styles.optinNameImageContainer}>
                            <WImage
                              alt={optinBrand.name}
                              src={optinBrand.image}
                              id={optinBrand.name}
                            />
                            <div className={styles.optinBrandName}>
                              <strong className={styles.name}>{optinBrand.name}</strong>
                              {optinBrand.informativa && (
                                <a
                                  href={optinBrand.informativa}
                                  target="_blank"
                                  rel="noreferrer"
                                  className={styles.optinBrandInformativa}
                                >
                                  {t("Leggi l'informativa Privacy")}
                                </a>
                              )}
                            </div>
                          </div>
                          <FormToggle
                            id={optinBrand.optinName}
                            className={'newsletter'}
                            checked={props.values[optinBrand.optinName]}
                            onChange={(e) => {
                              if (brandOptinName && e.target.id === brandOptinName) return
                              props.setFieldValue(e.target.id, e.target.checked)
                            }}
                            disabled={brandOptinName === optinBrand.optinName}
                          />
                        </div>
                      ))}
                  </div>
                )}


            <div className={styles.optins}>
          
              <p className={styles.privacy_title}>
                {t(
                  'Ai sensi e per gli effetti degli articoli artt. 7,13 e 15 del Regolamento UE 2016/679,'
                )}
              </p>
              <FormField
                status={
                  props.touched.optinMarketing
                    ? props.errors.optinMarketing
                      ? 'error'
                      : 'success'
                    : null
                }
                errorMessage={props.errors.optinMarketing}
                layout="full"
                className={styles.fieldMarketing}
              >
                <FormCheckbox
                  id="optinMarketing"
                  className={styles.labelCheck}
                  checked={props.values?.optinMarketing}
                  onChange={props.handleChange('optinMarketing')}
                  label={<OptinLabel type="commerciale" />}
                />
                {/* <Button
                  label={
                    preferenzeOpen
                      ? t('Nascondi le preferenze di ricontatto dei Brand Danone')
                      : t('Gestisci le tue preferenze di ricontatto dei Brand Danone')
                  }
                  variant="ghost"
                  size="sm"
                  className={styles.preferenzeTrigger}
                  onClick={() => setPreferenzeOpen(!preferenzeOpen)}
                /> */}
                
              </FormField>
        
        
            </div>
          </FormLayout>
      
          <div className={styles.buttons}>
            <Button
              disabled={!props.isValid || props.isSubmitting}
              className={styles.submit}
              type="submit"
              onClick={() => props.handleSubmit()}
              label={t('Iscriviti alla newsletter')}
              variant="primary"
            />
          </div>

          <ModalFeedback
            open={modalConfirmCreateAccount}
            setOpen={setModalConfirmCreateAccount}
            closeButton={true}
            onClose={(event) => {
              if (nextPage) router.push(nextPage)
              else {
                router.push('/login')
              }
            }}
            title={t('La tua iscrizione alla newsletter è avvenuta con successo!')}
            description={t(
              'Grazie del tuo interesse, ci vediamo presto nella casella di posta!'
            )}
           
          />
          <ModalFeedback
            open={modalErrorCreateAccount}
            setOpen={setModalErrorCreateAccount}
            closeButton={false}
            onClose={(event) => {
              setError('')
            }}
            title={t('Si è verificato un errore durante l\'iscrizione alla newsletter')}
            description={t(error)}
            ctaLabel={t('Torna all\'iscrizione alla newsletter')}
            showIcon={false}
          />
        </>
      )}
    </Formik>
  )
}

export default FormNewsletter
